import { CreateStationMarkerAtlas } from '@/components/map/station-marker/create-station-marker-atlas';
import { ICON_SIZE, PIN_H, PIN_W, TORCH_SIZE } from '@/utils/constants/map';
import { createCircleAtlas } from '@/utils/helpers/train-simulation/create-circle-atlas';
import { createDirectionTorchAtlas } from '@/utils/helpers/train-simulation/create-direction-torch-atlas';
import {
  createFlagBottomAtlas,
  createFlagTopAtlas,
} from '@/utils/helpers/train-simulation/create-flag-atlas';
import { createHazardIconAtlas } from '@/utils/helpers/train-simulation/create-hazard-icon-atlas';
import { createPillAtlas } from '@/utils/helpers/train-simulation/create-pill-atlas';
import { createPinIconAtlas } from '@/utils/helpers/train-simulation/create-pin-icon-atlas';
import { createRingAtlas } from '@/utils/helpers/train-simulation/create-ring-atlas';
import { createSlowSectionAtlas } from '@/utils/helpers/train-simulation/create-slow-section-atlas';

let ATLAS_CACHE: Record<string, string> | null = null;

export const getAtlases = () => {
  if (!ATLAS_CACHE && typeof document !== 'undefined') {
    ATLAS_CACHE = {
      journey: createPillAtlas(42, 20),
      journeyWithDangerousWagon: createPillAtlas(44, 16),
      deviation: createPillAtlas(30, 20),
      circle: createCircleAtlas(32),
      ring: createRingAtlas(64, 8),
      pinShape: createPillAtlas(PIN_W, PIN_H),
      pinIcon: createPinIconAtlas(ICON_SIZE),
      torch: createDirectionTorchAtlas(TORCH_SIZE),
      flagBottom: createFlagBottomAtlas(),
      flagTop: createFlagTopAtlas(),
      slowSectionLarge: createSlowSectionAtlas(true),
      slowSectionSmall: createSlowSectionAtlas(false),
      stationMarker: CreateStationMarkerAtlas(),
      dangerMarker: createHazardIconAtlas(),
    };
  }

  return ATLAS_CACHE;
};

export const VEREINA_ATLAS = createPillAtlas(40, 24);
